export default __webpack_public_path__ + "static/logo-giacomo-catalani-editore-cf55326445c2e7017c9cfffda16a4777.png";